export default __webpack_public_path__ + "static/media/new_msg.c3b220b5.png";